import React, { Component } from 'react';
import Bg from "../assets/img/bg.jpg";

const styles = {
    bg:{
        backgroundImage: 'url(' + Bg + ')',
    }
}

class Banner extends Component{
    render(){
        return(

            <div className="banner" style={{backgroundImage: "url(https://mportalsystem2.btect.sk"+ this.props.findImageBySlug("banner2")}} >
                <div className="container">

                    <div className="row">
                        <div className="col-md-7">
                        </div>
                        <div className="col-md-5">
                            <div className="whitebox">
                                <h5 className="nadpisbox">{this.props.findSlug("banner_nadpis")}</h5>
                                <p className="bannerparag">{this.props.findSlug("banner_text")}</p>
                                <a className="button" href={this.props.findSlug("banner_button_href")}>{this.props.findSlug("banner_button_text")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Banner;